import React from "react";
import { Link } from "gatsby";
import PromoGrid from "./PromoGrid";
import { getActivePromotions, PROMOTIONS_FOOTNOTE } from "../../data/promotions";

/**
 * Promociones vigentes de la home: las destacadas arriba, de a dos, y la
 * secundaria a todo el ancho, con el asterisco aclarado al pie.
 */
const Promotions = () => {

	const promotions = getActivePromotions();

	if (promotions.length === 0) return null;

	return (
		<section id="promociones" className="anchor-target bg-white py-16 lg:py-24">
			<div className="shell">
				<h2 className="display-2 mb-8 lg:mb-10">Promociones vigentes</h2>

				<PromoGrid promotions={ promotions } />

				<div className="mt-7 flex flex-col items-start justify-between gap-5 lg:flex-row lg:items-center">
					<p className="m-0 max-w-[560px] text-xs leading-relaxed text-muted">{ PROMOTIONS_FOOTNOTE }</p>

					<Link className="button button--primary w-full sm:w-auto" to="/promociones">
						Ver todas las promociones <span aria-hidden="true">→</span>
					</Link>
				</div>
			</div>
		</section>
	);
};

export default Promotions;
